"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERC721__factory = void 0;

var _contracts = require("@ethersproject/contracts");

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
class ERC721__factory extends _contracts.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static connect(address, signerOrProvider) {
    return new _contracts.Contract(address, _abi, signerOrProvider);
  }

}

exports.ERC721__factory = ERC721__factory;
const _abi = [{
  inputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "approved",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    indexed: false,
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "ApprovalForAll",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  constant: true,
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "approve",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "getApproved",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "bool",
    name: "approved",
    type: "bool"
  }],
  name: "setApprovalForAll",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "operator",
    type: "address"
  }],
  name: "isApprovedForAll",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "safeTransferFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_data",
    type: "bytes"
  }],
  name: "safeTransferFrom",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";